/* ==========================================================================
  main.js
========================================================================== */

/**
 * Navigation
 */
aucor_navigation(document.getElementById('primary-navigation'), {
  desktop_min_width: 890, // min width in pixels
  menu_toggle: '#menu-toggle' // selector for toggle
});

/**
 * Responsive videos
 */
fitvids();

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){

    // current <img> element
    var el = e.target;

    objectFitPolyfill();
    el.addEventListener('load', function() {
      objectFitPolyfill();
    });

  });
}

(function($){

  /**
   * Adds necessary logic to header search form
   */
  var search_form = function(){
    $('a[href="#search"]').on('click', function(event){
      event.preventDefault();
      $('.search-form-container').toggle();
      $('.search-form__input').focus();
    });
  };

  /**
   * Hyphenates long words - requires [data-hyphens] css styles to be correct
   */
  var hyphenate_long_words = function(){
    var pattern = /(\S{12,})/gi; // wordlenght you want to wrap
    var replaceWith = '<span data-hyphens>$1</span>'; // Here's the wap
    $('a, .nostoblokki__otsikko *, h1, h1 *, h2, h2 *, h3, h3 *, h4, h5, h6').each(function(){

      if ($(this).has('*').length){
        return;
      }

      if ($(this).html() !== undefined){
        $(this).html(
          $(this).html().replace(pattern,replaceWith)
        );
      }
    });
  };

  $(document).ready(function(){

    search_form();
    hyphenate_long_words();
    $('.videolink__url').simpleLightbox();

  });

  $(window).scroll(function(){
    if ($(window).scrollTop() >= 300) {
        $('header').addClass('header-scrolled-past');
        // .delay(100).queue(function(next){
        //   $(this).addClass('fixed-header');
        // });
    }
    else {
        $('header').removeClass('header-scrolled-past');
    }
  });

})(jQuery);
